<!-- Pug Template -->
<template lang="pug">
.list-article-sponsors
  .list-article-sponsors__intro(
    v-if="introduction_text"
  )
    h3 {{ introduction_text }}

  p ASA partners can help:

  .list-article-sponsors__list(
    ref="list"
  )
    .list-article-sponsors__list-item(
      v-for="sponsor in sponsors"
    )
      list-article-sponsor(
        :sponsor="sponsor"
      )
</template>

<!-- Script -->
<script>
const $ = jQuery;
import Flickity from 'flickity-imagesloaded';
import debounce from 'debounce';
import ListArticleSponsor from './list-article-sponsor';
export default {
  props: {
    introduction_text: String,
    sponsors: Array
  },

  data(){
    this.sponsors.sort( function(){
      return 0.5 - Math.random();
    });
    const sortedSponsors = this.sponsors;
    return {
      sortedSponsors
    }
  },

  components: {ListArticleSponsor},

  mounted(){

    const updateFlickity = debounce(() => this.updateFlickity(), 50)
    $(window).on('resize.list-article-sponsors orientationchange.list-article-sponsors', updateFlickity);
    updateFlickity();
  },

  destroyed(){
    $(window).off('.list-article-sponsors');
  },

  methods: {
    updateFlickity(){
      if( this.flickity ){
        this.flickity.destroy();
      }
      if( this.$refs.list.scrollWidth <= $(this.$refs.list).width() ){
        return;
      }
      
      this.flickity = new Flickity(this.$refs.list, {
        prevNextButtons: false,
        wrapAround: true,
        autoPlay: 3000,
        contain: false,
        cellAlign: 'left',
        pageDots: false,
        imagesLoaded: true
      });
    }
  }
};
</script>

<!-- SCSS Style -->
<style lang="scss">
@import '../../../scss/front/variables'; 
@import "~bootstrap/scss/_functions";
@import "~bootstrap/scss/_variables";
@import "~bootstrap/scss/_mixins";

.list-article-sponsors {
  margin: 2rem 0;
  padding: 2rem 1rem;
  border: 1px solid $color-gray-2;
  border-radius: 0.75em;
  text-align: center;
  &__intro {
    color: $color-warm-gray-11;
    h3 {
      font-weight: 600;
      color: inherit;
    }
  }
  &__list {
    padding: 0;
    display: flex;
    justify-content: center;
    flex-wrap: nowrap;
    overflow: hidden;
    &.flickity-enabled {
      display: block;
      overflow: auto;
    }

    &-item {
      list-style: none;
      margin: 0;
      padding: 0 1em;
      width: 100%;
      flex-basis: 100%;
      flex-shrink: 0;
      flex-grow: 0;
      @include media-breakpoint-up(md){
        width: 50%;
        flex-basis: 50%;
      }
      @include media-breakpoint-up(lg){
        width: 33%;
        flex-basis: 33%;

      }
    }
  }
}
</style>